import { render, staticRenderFns } from "./WPTextfield.vue?vue&type=template&id=4a8258a7"
import script from "./WPTextfield.vue?vue&type=script&lang=ts"
export * from "./WPTextfield.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports